import React, { useContext, useRef, useState } from "react";

// import Breadcrumps from "../../components/Breadcrumps";
import Toptab from "../Toptab/Toptab";
import Breadcrumps from "../Toptab/Breadcrumps";
import { AppContext } from "../../../context/AppContext";
import { multipartPostCallWithErrorResponse, simpleGetCall, simpleGetCallWithToken } from "../../../api/ApiServices";
// import ApiConfig from "../../../api/ApiConfig";
import { toast } from "react-toastify";
import { ToastMsg } from "../../TostMsg";
import { Spinner } from "react-bootstrap";
import { notifyError } from "../../../toaster/notify";
import StoreSelector from "../../StoreSelector";

const BaseMenu = () => {

  const { sidebar, activeTab, setActiveTab, selectedStoreID,ApiConfig,storesList, 
    setSelectedStoreID, 
    permissions} = useContext(AppContext);

  let ref = useRef(null)
  let ref2 = useRef(null)
const [loading , setLoading] = useState(false);
const [syncloading , setSyncLoading] = useState(false);
  const handleEcxportProducs = (e, type) => {

    let formData = new FormData()

    formData.append('shop_id', selectedStoreID)
    formData.append('file', e.target.files[0])
    
    const url = type === "pooja" ? ApiConfig.POST_SYNC_PET_POOJA : ApiConfig.IMPORT_PRODUCTS ;
 if(type === 'pooja'){
  setSyncLoading(true)
 }
 multipartPostCallWithErrorResponse(url, formData).then((res) => {

      if (res.json.success) {
        ToastMsg('success', res?.json.message)
      } else {
         ToastMsg('error', res?.json.message || "Something went wrong")
      }

    }).catch((error)=>{

    }).finally(()=>{
      setSyncLoading(false)
    })

  }

function  downloadExcelFromResponse   (response, fileName = 'report.xlsx') {
  setLoading(true);
  response.blob().then(blob => {
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
  });

  setLoading(false);
}



const getExportProduct = async () => {
  setLoading(true);
  if(!selectedStoreID) {
    notifyError("Please select a restaurant");
 setLoading(false);
  return;
  }
 
  try {
    const response = await fetch(
      ApiConfig.EXPORT_PRODUCTS(selectedStoreID),
      {
        method: 'GET',
         headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("Token"),
    },
      }
    );

    if (!response.ok) {
      throw new Error('Download failed');
    }

    downloadExcelFromResponse(response, 'products.xlsx');
  } catch (err) {
    notifyError("Something went wrong")
    console.error('Status API Error:', err);
  } finally {
    setLoading(false);
  }
};



  return (
    <div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
    >
      <input type="file" style={{ display: 'none' }}
        ref={ref}
        onChange={(e)=>handleEcxportProducs(e ,'normal')}
        accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      />
      <input type="file" style={{ display: 'none' }}
        ref={ref2}
        onChange={(e)=>handleEcxportProducs(e, 'pooja')}
        accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      />
      <div className="role-content">
        <div className="sub-header-role ">
          <h6 className="mt-2">Menu List</h6>
          {permissions && permissions["View Inventory Management"] && (
            <StoreSelector
              options={Array.isArray(storesList) ? storesList.map(store => ({
                value: store.value,
                label: store.label,
              })) : []}
              value={selectedStoreID}
              onChange={(value) => {
                setSelectedStoreID(value);
                localStorage.setItem("selectedStoreId", value);
              }}
            />
          )}
          <div className="w-[20%] w-sm-1/4  text-start">
          {/* <div className="d-flex"> */}
             <button disabled={syncloading} style={{ backgroundColor: "#53B7E8", color: "#fff" }} className="btn btn-" type="button"
              onClick={() => {
                ref2.current.click()
              }}
            >
             {syncloading ? <Spinner size='sm' /> : "Sync Pet Pooja"} 
            </button>

            <button style={{ backgroundColor: "#53B7E8", color: "#fff" }} className="btn btn-" type="button"
              onClick={() => {
                ref.current.click()
              }}
            >
              Import Products
            </button>
         
         
            <button style={{ backgroundColor: "#53B7E8", color: "#fff" }} className="btn btn-" type="button"
              onClick={getExportProduct}
              disabled={loading}
            >
              {loading ?  <Spinner size="sm" />  : "Export Products"}
              
            </button>
            </div>
         
        </div>
        <div className="h-screen bg-white mt-3" style={{ overflow: "auto", borderRadius: "10px" }}>
          {/* Breadcrumb with activeTab passed as a prop */}
          {/* <Breadcrumps activeTab={activeTab} /> */}

          {/* Toptab with activeTab and setActiveTab passed as props */}
          <Toptab activeTab={activeTab} setActiveTab={setActiveTab} />

          {/* Content */}
          <div className="container mt-4">{/* Add content here */}</div>
        </div>
      </div>
    </div>
  );
};

export default BaseMenu;